"use client";
import React, { useState, useEffect } from "react";
import { useSearchParams } from "next/navigation";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "@/components/Button";
import Form from "react-bootstrap/Form";
import Stack from "react-bootstrap/Stack";
import SlideCarousel from "@/components/SlideCarousel";
import Ratio from "react-bootstrap/Ratio";
import "@/styles/ListingPage.scss";
import Script from "next/script";
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import {
  fetchListingData,
  modalHelper,
  postFormData,
} from "@/components/services/QueryDataHelper";
import type { ModalMessage } from "@/types/data.types";

function ListingPage({id, community}:{id: string, community: string}) {
  const queryClient = useQueryClient();
  const { setModal, setSubdivision, setResultModal } = modalHelper(queryClient);
  const setListingSource = (newListingSrc: string) => {
    queryClient.setQueryData(["RES-DATA"], (prevState: any) => {
      return { ...prevState, listingSource: newListingSrc };
    });
  };

  const searchParams = useSearchParams();
  const [formValues, setFormValues] = useState<any>({ cs: 0 });
  const [validated, setValidated] = useState(false);
  const { data, error, isLoading, isFetching } = useQuery({
    queryKey: ["LISTING-DATA", id],
    queryFn: () => fetchListingData("listing", id),
    staleTime: 300000,
  });
  const {
    mutate: postForms,
    data: formResponse,
    isSuccess,
    isError,
  } = useMutation({
    mutationKey: ["FORM-DATA"],
    mutationFn: (formData:any) => postFormData(formData),
  });

  const [iframeSrc, setIframeSrc] = useState("");
  const [iframeBtn, setIframeBtn] = useState("");

  const handleChange = (event: any) => {
    const val = event.target.value;
    const id = event.target.id;
    const newformValues = {
      ...formValues,
      [id]: val,
    };
    setFormValues(newformValues);
  };

  const handleSubmit = (event: any) => {
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
    } else {
      event.preventDefault();
      event.stopPropagation();
      console.log(form.elements);
      let formCookies = {};
      let formName = form.elements.cta.value.toLowerCase();
      let postUrl = "form";
      let storeFormData = true;
      for (let x = 0; x < form.elements.length; x++) {
        switch (form.elements[x].id) {
          case "cs":
            {
              if (
                Number(form.elements.ts.value) >
                Number(form.elements[x].value) + 1
              ) {
                formCookies = {
                  ...formCookies,
                  [form.elements[x].id]: Number(form.elements[x].value) + 1,
                };
                const newformValues = {
                  ...formValues,
                  [form.elements[x].id]: Number(form.elements[x].value) + 1,
                };
                setFormValues(newformValues);
              }
            }
            break;
          case "fullname":
          case "fname":
          case "lname":
          case "mobile":
          case "email":
            {
              formCookies = {
                ...formCookies,
                [form.elements[x].id]: form.elements[x].value,
              };
            }
            break;
          default:
            break;
        }
      }

      switch (formName) {
        default:
          {
            storeFormData = true;
            formName = "formData";
          }
          break;
      }
      if (storeFormData)
        localStorage.setItem(formName, JSON.stringify(formCookies));
      let canSubmit =
        Number(form.elements.cs.value) + 1 >= Number(form.elements.ts.value);
      setValidated(canSubmit);
      if (canSubmit) {
        const postDataValues = {
          ...formValues,
          neighborhood: form.elements.neighborhood?.value,
          cs: Number(form.elements.cs.value) + 1,
          ts: Number(form.elements.ts.value),
          cta: form.elements.cta.value,
          sto: form.elements.sto ? form.elements.sto.value : null,
          url: window.location.href,
        };
        postForms({ data: postDataValues, api: postUrl });
      }
    }
  };

  useEffect(() => {
    if (community) {
      setSubdivision(
        community
          .replaceAll("-and-", "&")
          .replaceAll("-", " ")
          .replaceAll("  ", " -")
          .trim()
          .toLowerCase()
          .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase())
      );
    } else {
      let queryCommunity = searchParams.get("community");
      if (queryCommunity)
        setSubdivision(
          queryCommunity
            .replaceAll("-and-", "&")
            .replaceAll("-", " ")
            .replaceAll("  ", " -")
            .trim()
            .toLowerCase()
            .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase())
        );
    }
    if (!searchParams.get("frm") && !searchParams.get("displayForm"))
      setModal("homeslist");
    let newformValues:any = {};
    if (localStorage["formData"]) {
      newformValues = JSON.parse(localStorage["formData"]);
      newformValues["cs"] = 0;
    } else {
      newformValues = { ...formValues, cs: 0 };
    }
    setFormValues(newformValues);
  }, []);

//   useEffect(() => {
//     window.navigation.addEventListener("navigate", urlChangeEventHandler);

//     function urlChangeEventHandler(event) {
//       console.log("location changed!");
//     //   if (document.readyState === "loading") {
//         // Loading hasn't finished yet
//         document.addEventListener("DOMContentLoaded", window.initMap());
//     //   } else {
//     //     // `DOMContentLoaded` has already fired
//     //     window.initMap();
//     //   }
//     //   if (typeof window?.initMap !== "undefined") {
//     //     window.initMap();
//     //   }
//     }

//     return () => {
//       // Remove the handler when the component unmounts
//       window.navigation.removeEventListener("navigate", urlChangeEventHandler);
//     };
//   }, []);

  useEffect(() => {
    // queryClient.invalidateQueries({ queryKey:["LISTING-DATA"]});
  }, [id]);

  useEffect(() => {
    if (data) {
      let srcUrl = "/assets/images/RES-Luxury-Group.webp";
      let btnType = "";
      if (data.PlayListURL) {
        btnType = "PlayList";
        // if(data.PlayListURL.startsWith("PL"))
        // {
        //     srcUrl = `https://www.youtube.com/embed?listType=playlist&list=${data.PlayListURL}&modestbranding=1&autoplay=0&rel=0&fs=0enablejsapi=1`;
        // }
        // else
        // {
        //     srcUrl = `https://www.youtube.com/embed/${data.PlayListURL}?version=3&autoplay=1&rel=0&fs=0&modestbranding=1&enablejsapi=1`;
        // }
        srcUrl = data.PlayListURL;
      } else if (data.MatrixURL) {
        btnType = "Matrix";
        srcUrl = data.MatrixURL;
      } else if (data.VirtualTourURL) {
        btnType = "VTour";
        // if(data.MyListing)
        // {
        //     srcUrl = `/vTour/${data.MLS}?nav=N`;
        // }
        // else
        // {
        //     srcUrl = data.VirtualTourURL;
        // }
        srcUrl = data.VirtualTourURL;
      }
      setIframeBtn(btnType);
      setIframeSrc(srcUrl);
      if (!data.MyListing) {
        setListingSource(
          `Listing information courtesy of: ${data.ListAgentFullName} of ${data.ListOfficeName} • ${data.ListAgentPreferredPhone}`
        );
      }
    }
  }, [data]);

  useEffect(() => {
    if (isSuccess) {
      setResultModal(formResponse.ModalMessage);
      setModal("results");
      if (formResponse?.Action) {
        try {
          const actionFunction = new Function(formResponse.Action);
          actionFunction();
        } catch (error) {
          console.error("Error executing action:", error);
        }
      }
    }
  }, [formResponse]);

  useEffect(() => {
    if (isError) {
      const errorModal: ModalMessage = {
        Header:
          "<Modal.Title data-react='true'>Error Encountered</Modal.Title>",
        Body: "<p>This is very embarrassing, but I have encountered a problem while attempting to process your submission. I will have my development team look into the logs and resolve the issue. Thank you for your understanding! Feel free to contact us directly RES Luxury Group, eXp Realty: <a href='tel:+13527941426' aria-label='Click to automatically dial from mobile device' title='Click to automatically dial from mobile device'>352.794.1426</a></p>",
        Footer: "",
      };
      setResultModal(errorModal);
      // setResultFooter(<Button size="lg" variant="blue" onClick={()=>dispatch(setModal(""))}>Ok</Button>);
      setModal("results");
    }
  }, [isError]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isFetching]);

  if (data && !isFetching) {
    const ranImgNum = Math.floor(Math.random() * data.Images?.length);
    const streetAddress = [
      data.StreetNumber,
      data.StreetDirPrefix,
      data.StreetName,
      data.StreetSuffix,
      data.StreetDirSuffix,
    ].join(" ");
    const fullAddress = `${streetAddress} ${data.City}, ${data.StateOrProvince} ${data.PostalCode}`;
    return (
      <section>    
        {/* <Helmet>
                <meta name="description" content={`${data.PublicRemarks.replace("<p class="indent">", "").replace("</p>", "")}`} />
                <meta itemprop="contentLocation" content={`${data.City}, ${data.StateOrProvince}`} />
                <meta property="og:description" content={`${data.PublicRemarks.replace("<p class="indent">", "").replace("</p>", "")}`} />
                <meta name="twitter:description" content={`${data.PublicRemarks.replace("<p class="indent">", "").replace("</p>", "")}`} />

            </Helmet>              */}
        <div
          style={{
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            backgroundSize: "cover",
            opacity: 1,
            backgroundAttachment: "fixed",
            backgroundImage: `url(${
              data.Images?.length > 0
                ? `${data.BaseImageURL}homes-for-sale-${
                    data.SubdivisionName
                      ? data.SubdivisionName.toLowerCase()
                          .replaceAll(" & ", "-and-")
                          .replaceAll(" ", "-")
                          .replaceAll("_", "-")
                      : data.CountyOrParish.toLowerCase()
                          .replaceAll(" ", "-")
                          .replaceAll("_", "-")
                  }_${data.Images[0]}`
                : `/assets/images/listings/mls/${id}/homes-for-sale-${
                    data.SubdivisionName
                      ? data.SubdivisionName.toLowerCase()
                          .replaceAll(" & ", "-and-")
                          .replaceAll(" ", "-")
                          .replaceAll("_", "-")
                      : data.CountyOrParish.toLowerCase()
                          .replaceAll(" ", "-")
                          .replaceAll("_", "-")
                  }_1.jpg`
            })`,
            // backgroundImage: `url(${
            //   data.Images?.length > 0
            //     ? `${data.BaseImageURL}${data.Images[0]}`
            //     : `/assets/images/listings/mls/${id}/1.jpg`
            // })`,            
            height: "100vh",
          }}
        >
          <div className="PropertyAddressDiv">
            <h2>
              {data.MlsStatus.toLowerCase() != "active" && (
                <>
                  <span className="listing-status">{data.MlsStatus}</span>
                  <br />
                </>
              )}
              {streetAddress}
            </h2>
            <hr />
            <h4>{`${data.City}, ${data.StateOrProvince} ${data.PostalCode}`}</h4>
            <h3>
              Offered at
              <span className="text-nowrap">
                {" "}
                {new Intl.NumberFormat("en-US", {
                  currency: "USD",
                  style: "currency",
                  maximumFractionDigits: 0,
                  minimumFractionDigits: 0,
                }).format(data.ListPrice)}
              </span>
            </h3>
            {new Date() < new Date(data.OpenHouseDate) && (
              <h4 dangerouslySetInnerHTML={{ __html: data.OpenHouseInfo }}></h4>
            )}
          </div>
        </div>
        <Row
          className="justify-content-md-center"
          style={{
            textAlign: "center",
            backgroundColor: "#1b1e2a",
            padding: "3% 10%",
            borderBottom: "5px solid #fff",
          }}
        >
          <Col>
            <h2 title="Bedrooms">
              {new Intl.NumberFormat("en-US", {
                maximumFractionDigits: 2,
                minimumFractionDigits: 0,
              }).format(data.BedroomsTotal)}
            </h2>
            <i
              className="icon ico-bed"
              aria-label="Bedrooms"
              title="Bedrooms"
            ></i>
          </Col>
          <Col>
            <h2 title="Bathrooms">
              {new Intl.NumberFormat("en-US", {
                maximumFractionDigits: 2,
                minimumFractionDigits: 0,
              }).format(data.BathroomsTotalInteger)}
            </h2>
            <i
              className="icon ico-bath"
              aria-label="Bathrooms"
              title="Bathrooms"
            ></i>
          </Col>
          <Col>
            <h2 title="Living Area Square Feet">
              {new Intl.NumberFormat("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
              }).format(data.LivingArea)}
            </h2>
            <i
              className="icon ico-sqft"
              aria-label="Living Area Square Feet"
              title="Living Area Square Feet"
            ></i>
          </Col>
          <Col>
            <h2 title="Garages">
              <span className="text-nowrap">
                {data.GarageSpaces as number > 0
                  ? `${new Intl.NumberFormat("en-US", {
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 0,
                    }).format(data.GarageSpaces)}-Car`
                  : "No"}
              </span>
            </h2>
            <i
              className="icon ico-car"
              aria-label="Garages"
              title="Garages"
            ></i>
          </Col>
          <Col>
            <h2 title="Year Build">
              {data?.YearBuilt ? data.YearBuilt : "--"}
            </h2>
            <i
              className="icon ico-hammer"
              aria-label="Year Build"
              title="Year Build"
            ></i>
          </Col>
          <Col>
            <h2 title="Acres">
              {new Intl.NumberFormat("en-US", {
                maximumFractionDigits: 2,
                minimumFractionDigits: 0,
              }).format(data.LotSizeAcres)}
            </h2>
            <i className="icon ico-acres" aria-label="Acres" title="Acres"></i>
          </Col>
        </Row>
        <Row
          style={{
            color: "#000",
            backgroundColor: "#e2e3e4",
            minHeight: "50vh",
          }}
        >
          <Row>
            <Col className="p-4" md={4}>
              <Row>
                <Col className="p-2">
                  <Button
                    className="w-100 h-100 float-end"
                    variant="blue"
                    size="lg"
                    title={
                      !data.PlayListURL
                        ? "No Video Tour available"
                        : "Load Video Tours"
                    }
                    aria-label={
                      !data.PlayListURL
                        ? "No Video Tour available"
                        : "Load Video Tours"
                    }
                    disabled={!data.PlayListURL}
                    active={iframeBtn == "PlayList"}
                    onClick={() => {
                      setIframeBtn("PlayList");
                      setIframeSrc(data.PlayListURL);
                    }}
                  >
                    Video Tours
                    <br />
                    <i role="presentation" className="icon ico-video"></i>
                  </Button>
                </Col>
                <Col className="p-2">
                  <Button
                    className="w-100  h-100"
                    variant="blue"
                    size="lg"
                    title={
                      !data.VirtualTourURL
                        ? "No 360° Virtual Tour available"
                        : " Load 360° Virtual Tours"
                    }
                    aria-label={
                      !data.VirtualTourURL
                        ? "No 360° Virtual Tour available"
                        : " Load 360° Virtual Tours"
                    }
                    disabled={!data.VirtualTourURL}
                    active={iframeBtn == "VTour"}
                    onClick={() => {
                      setIframeBtn("VTour");
                      setIframeSrc(data.VirtualTourURL);
                    }}
                  >
                    360° Virtual Tours
                    <br />
                    <i role="presentation" className="icon ico-360tour"></i>
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col className="p-2">
                  <Button
                    className="w-100 h-100 float-end"
                    variant="blue"
                    size="lg"
                    title={
                      !data.VirtualOpenHouseURL
                        ? "No Virtual Open House available"
                        : "Load Virtual Open House"
                    }
                    aria-label={
                      !data.VirtualOpenHouseURL
                        ? "No Virtual Open House available"
                        : "Virtual Open House Tour"
                    }
                    disabled={!data.VirtualOpenHouseURL}
                    active={iframeBtn == "VHouse"}
                    onClick={() => {
                      setIframeBtn("VHouse");
                      setIframeSrc(data.VirtualOpenHouseURL);
                    }}
                  >
                    Virtual Open House
                    <br />
                    <i role="presentation" className="icon ico-vtour"></i>
                  </Button>
                </Col>
                <Col className="p-2">
                  <Button
                    className="w-100 h-100"
                    variant="blue"
                    size="lg"
                    title={
                      !data.MatrixURL
                        ? "No Listing Information Sheet available"
                        : "Load Listing Information Sheet"
                    }
                    aria-label={
                      !data.MatrixURL
                        ? "No Listing Information Sheet available"
                        : "Load Listing Information Sheet"
                    }
                    disabled={!data.MatrixURL}
                    active={iframeBtn == "Matrix"}
                    onClick={() => {
                      setIframeBtn("Matrix");
                      setIframeSrc(data.MatrixURL);
                    }}
                  >
                    Listing Information
                    <br />
                    <i role="presentation" className="icon ico-info"></i>
                  </Button>
                </Col>
              </Row>
              {data.ListingDocsURL && (
                <Row>
                  <Col className="p-2">
                    <Button
                      className="w-100 h-100 float-end"
                      variant="blue"
                      size="lg"
                      title="Load Additional Listing Documents"
                      aria-label="Load Additional Listing Documents"
                      active={iframeBtn == "Docs"}
                      onClick={() => {
                        setIframeBtn("Docs");
                        setIframeSrc(data.ListingDocsURL);
                      }}
                    >
                      Additional Documents
                      <br />
                      <i role="presentation" className="icon ico-pdf"></i>
                    </Button>
                  </Col>
                </Row>
              )}
              <Row className="pt-4">
                <Col className="text-center">
                  For more details contact RES Luxury Group, eXp Realty: <br />
                  <a
                    href="tel:+13527941426"
                    aria-label="Click to automatically dial from mobile device a real estate agent"
                    title="Click to automatically dial from mobile device a real estate agent"
                  >
                    352.794.1426
                  </a>{" "}
                  &bull;{" "}
                  <a
                    href={`mailto:Homes@RESLuxuryGroup.com?subject=${fullAddress}`}
                    aria-label="Click to email RES Luxury Group, LLC"
                    title="Click to email RES Luxury Group, LLC"
                  >
                    Homes@RESLuxuryGroup.com
                  </a>
                </Col>
              </Row>
              <Row className="pb-4">
                <Col className="d-flex justify-content-center">
                  <Button
                    variant="blue"
                    size="sm"
                    target="_blank"
                    rel="noopener"
                    title="Share real estate property via Text/SMS Message"
                    aria-label="Share real estate property via Text/SMS Message"
                    href={`sms:?body=Look%20at%20this%20property!%20${window.location.href}`}
                  >
                    <i role="presentation" className="bi bi-chat-left-text"></i>{" "}
                    Share
                  </Button>
                </Col>
                <Col className="d-flex justify-content-center">
                  <Button
                    variant="blue"
                    size="sm"
                    target="_blank"
                    rel="noopener"
                    title="Share real estate property via Twitter"
                    className="twitter-share-button"
                    aria-label="Share real estate property via Twitter"
                    href={`https://twitter.com/intent/tweet?text=Look%20at%20this%20property!&url=${window.location.href}`}
                  >
                    <i
                      role="presentation"
                      className="button-icon twitter-logo"
                    ></i>{" "}
                    Tweet
                  </Button>
                </Col>
                <Col className="d-flex justify-content-center">
                  <Button
                    variant="blue"
                    size="sm"
                    className="fb-xfbml-parse-ignore"
                    title="Share real estate property via Facebook"
                    aria-label="Share real estate property via Facebook"
                    rel="noopener"
                    target="_blank"
                    href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}&amp;src=sdkpreparse`}
                  >
                    <i
                      role="presentation"
                      className="button-icon facebook-logo"
                    ></i>{" "}
                    Share
                  </Button>
                </Col>
              </Row>
              <Stack gap={2}>
                {data.SubdivisionName != "Farms" ? (
                  <div>
                    <b>Location:</b> {data.SubdivisionName}
                  </div>
                ) : (
                  <></>
                )}
                {data.ElementarySchool ||
                data.MiddleSchool ||
                data.HighSchool ? (
                  <div>
                    <b>Schools:</b>{" "}
                    {`${data.ElementarySchool}, ${data.MiddleSchool}, ${data.HighSchool}`}
                  </div>
                ) : (
                  <></>
                )}
                {data.PoolPrivateYN ? (
                  <div>
                    <b>Pool:</b> {data.PoolFeatures}
                  </div>
                ) : (
                  <></>
                )}
                {data.WaterfrontYN ? (
                  <div>
                    <b>Waterfront:</b>{" "}
                    {`${data.WaterfrontFeatures} on ${data.WaterBodyName}`}
                  </div>
                ) : (
                  <></>
                )}
                {data.InteriorFeatures ? (
                  <div>
                    <b>Interior Features:</b>{" "}
                    <span
                      dangerouslySetInnerHTML={{
                        __html: data.InteriorFeatures,
                      }}
                    ></span>
                  </div>
                ) : (
                  <></>
                )}
                {data.Flooring ? (
                  <div>
                    <b>Flooring:</b>{" "}
                    <span
                      dangerouslySetInnerHTML={{ __html: data.Flooring }}
                    ></span>
                  </div>
                ) : (
                  <></>
                )}
                {data.Appliances ? (
                  <div>
                    <b>Equipment &amp; Appliances:</b>{" "}
                    <span
                      dangerouslySetInnerHTML={{ __html: data.Appliances }}
                    ></span>
                  </div>
                ) : (
                  <></>
                )}
              </Stack>
            </Col>
            <Col md={8}>
              {data.MyListing ? (
                <Ratio aspectRatio="4x3">
                  <iframe
                    width="100%"
                    height="100%"
                    src={iframeSrc}
                    allowFullScreen
                    allow="autoplay"
                  ></iframe>
                </Ratio>
              ) : (
                <iframe
                  width="100%"
                  height="100%"
                  src={iframeSrc}
                  allowFullScreen
                  allow="autoplay"
                ></iframe>
              )}
            </Col>
          </Row>
          <Row>
            <Col className="p-4">
              <b>Property Description:</b>
              <div
                className="indent"
                dangerouslySetInnerHTML={{ __html: data.PublicRemarks }}
              ></div>
            </Col>
          </Row>
        </Row>
        <SlideCarousel
          className="listing-carousel"
          slideType="listing"
          queryValue={id}
          slideCount={1}
          controls={true}
          cardWrapper={false}
          bg="trans-black"
        />
        <Row className="PropertyMapRow">
          <Col className="py-1" lg={8}>
            <Ratio aspectRatio="4x3">
              <div id="map" className="w-100 text-black"></div>
            </Ratio>
            <Script type="text/javascript">{`                   
                        function initMap() {
                            let myLatlng = new google.maps.LatLng(28.9325846, -82.5073917);

                            let mapOptions = {
                                zoom: ${data?.Coordinates?.Latitude ? "15": "10"},
                                center: myLatlng,
                                scrollwheel: false,
                                styles: [{ "featureType": "administrative.land_parcel", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "landscape.man_made", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "road", "elementType": "labels", "stylers": [{ "visibility": "simplified" }, { "lightness": 20 }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "hue": "#f49935" }] }, { "featureType": "road.highway", "elementType": "labels", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "hue": "#fad959" }] }, { "featureType": "road.arterial", "elementType": "labels", "stylers": [{ "visibility": "off" }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road.local", "elementType": "labels", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "elementType": "all", "stylers": [{ "hue": "#a1cdfc" }, { "saturation": 30 }, { "lightness": 49 }] }]
                            };

                            let mapElement = document.getElementById("map");
                            let map = new google.maps.Map(mapElement, mapOptions);  
                            ${data?.Coordinates?.Latitude && `
                                let geoLatitude = ${data.Coordinates?.Latitude};
                                let geoLongitude = ${data.Coordinates?.Longitude};

                                let latlng = new google.maps.LatLng(geoLatitude, geoLongitude);
                                let infowindow = new google.maps.InfoWindow({
                                    content: "${fullAddress}"
                                });
                                let marker = new google.maps.Marker({
                                    position: latlng,
                                    map: map,
                                    title: "click for details"
                                });
                                marker.addListener("click", function () {
                                    infowindow.open(map, marker);
                                });
                                infowindow.open(map, marker);
                                map.setCenter(latlng);`
                            }
                        }
                        fbq("trackCustom", "PropertyView", { MLS: "${data.MLS}", Subdivision: "${data.SubdivisionName}", URL: "${window.location.href}", Property: "${fullAddress}" });
                        initMap();
                    `}</Script>
          </Col>
          <Col className="p-4" lg={4}>
            <h3>
              Homes for sale
              {data.SubdivisionName ? ` in ${data.SubdivisionName}` : ``}
            </h3>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <p>
                Please complete the form below to request your FREE list of{" "}
                {data.SubdivisionName} homes for sale.
              </p>
              <Row>
                <Col lg="11">
                  <Form.Group
                    className="form-floating mb-3"
                    controlId="fname"
                  >
                    <Form.Control
                      type="text"
                      placeholder="First name (Required)"
                      maxLength={256}
                      value={formValues["fname"] || ""}
                      onChange={handleChange}
                      required
                    />
                    <Form.Label>First Name (Required)</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      Please provide first name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg="11">
                  <Form.Group
                    className="form-floating mb-3"
                    controlId="lname"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Last name (Required)"
                      maxLength={256}
                      value={formValues["lname"] || ""}
                      onChange={handleChange}
                      required
                    />
                    <Form.Label>Last Name (Required)</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      Please provide last name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col sm="9" lg="11">
                  <Form.Group
                    className="form-floating mb-3"
                    controlId="email"
                  >
                    <Form.Control
                      type="email"
                      placeholder="Email (Required)"
                      maxLength={256}
                      value={formValues["email"] || ""}
                      onChange={handleChange}
                      required
                    />
                    <Form.Label>Email (Required)</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      Please provide email address.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col sm="3" lg="11">
                  <Form.Group
                    className="form-floating mb-3"
                    controlId="mobile"
                  >
                    <Form.Control
                      type="tel"
                      placeholder="Mobile (Required)"
                      value={formValues["mobile"] || ""}
                      onChange={handleChange}
                      pattern="^\d{3}-?\d{3}-?\d{4}$"
                      required
                    />
                    <Form.Label>Mobile (Required)</Form.Label>
                    <Form.Control.Feedback type="invalid">
                      Please provide mobile phone number.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <div className="me-auto">
                  <i role="presentation" className="bi bi-shield-lock-fill"></i>{" "}
                  We respect your{" "}
                  <a
                    href="/real-estate/privacy-policy"
                    aria-label="RES Luxury Group - Privacy Policy"
                    title="RES Luxury Group - Privacy Policy"
                    target="_blank"
                  >
                    privacy
                  </a>{" "}
                  and will not share or resell your information.
                </div>
                <div className="py-4 clearfix">
                  <Button
                    className="float-end mx-4"
                    size="lg"
                    variant="blue"
                    type="submit"
                  >
                    Get List Now{" "}
                    <i
                      role="presentation"
                      className="bi bi-caret-right-fill"
                    ></i>
                  </Button>
                </div>
                <input
                  type="hidden"
                  id="neighborhood"
                  name="neighborhood"
                  value={data.SubdivisionName}
                />
                <input
                  type="hidden"
                  name="cs"
                  id="cs"
                  value={formValues["cs"] || 0}
                />
                <input type="hidden" name="ts" id="ts" value={1} />
                <input type="hidden" id="cta" name="cta" value="HomesList" />
              </Row>
            </Form>
          </Col>
        </Row>
        <Script type="application/ld+json">{`
            [
            {
            "@context": "https://schema.org",
            "@type": "SingleFamilyResidence",
            "name": "${data.City} home for sale - ${streetAddress}",
            "description": "${data.PublicRemarks.replace("<p class=\"indent\">", "").replace("</p>", "")}",
            "numberOfRooms": ${new Intl.NumberFormat("en-US", {maximumFractionDigits: 2,  minimumFractionDigits: 0 }).format(data.RoomsTotal)},
            "floorSize": {
            "@context": "https://schema.org",
            "@type": "QuantitativeValue",
            "value": "${new Intl.NumberFormat("en-US", {maximumFractionDigits: 0,  minimumFractionDigits: 0 }).format(data.LivingArea)}",
            "unitCode": "FTK"
            },
            "numberOfBathroomsTotal": ${new Intl.NumberFormat("en-US", {maximumFractionDigits: 2,  minimumFractionDigits: 0 }).format(data.BathroomsTotalInteger)},
            "numberOfBedrooms": ${new Intl.NumberFormat("en-US", {maximumFractionDigits: 2,  minimumFractionDigits: 0 }).format(data.BedroomsTotal)},
            "yearBuilt": ${data.YearBuilt},
            "address": {
            "@context": "https://schema.org",
            "@type": "PostalAddress",
            "addressCountry": "US",
            "addressLocality": "${data.City}",
            "addressRegion": "${data.StateOrProvince}",
            "postalCode": "${data.PostalCode}",
            "streetAddress": "${streetAddress}"
            },
            "telephone": "+1-352-794-1426",
            "photo": {
            "@context": "https://schema.org",
            "@type": "ImageObject",
            "url": "https://www.guaranteedtosell.homes${data.Images?.length>0 ? `${data.BaseImageURL}${data.Images[0]}` : `https://www.guaranteedtosell.homes/assets/images/bo-image.jpg`}",
            "name": "${data.City} home for sale - ${streetAddress}",
            "description": "${data.PublicRemarks.replace("<p class=\"indent\">", "").replace("</p>", "")}"
            },
            "url": "${window.location.href}"
            },
            {
            "@context": "https://schema.org",
            "@type": "Product",
            "name": "${data.City} home for sale - ${streetAddress}",
            "description": "${data.PublicRemarks.replace("<p class=\"indent\">", "").replace("</p>", "")}",
            "identifier":"${data.MLS}",
            "productID":"${data.MLS}",
            "image": {
            "@context": "https://schema.org",
            "@type": "ImageObject",
            "url": "https://www.guaranteedtosell.homes${data.Images?.length>0 ? `${data.BaseImageURL}${data.Images[0]}` : `https://www.guaranteedtosell.homes/assets/images/bo-image.jpg`}",
            "name": "${data.City} home for sale - ${streetAddress}",
            "description": "${data.PublicRemarks.replace("<p class=\"indent\">", "").replace("</p>", "")}"
            },
            "url": "${window.location.href}",
            "offers":{
            "@context": "https://schema.org",
            "@type": "Offer",
            "priceCurrency": "USD",
            "price": "${data.ListPrice}",
            "offeredBy": {
            "@context": "https://schema.org",
            "@type": "Person",
            "name": "RES Luxury Group",
            "telephone": "+1-352-794-1426",
            "email": "Homes@RESLuxuryGroup.com"
            },
            "businessFunction": "http://purl.org/goodrelations/v1#Sell",
            "itemOffered": "home for sale"
            },
            "additionalType": "http://www.productontology.org/id/Real_estate"
            },
            {
            "@context": "https://schema.org",
            "@type": "RealEstateAgent",
            "name": "RES Luxury Group",
            "telephone": "+1-352-794-1426",
            "email": "Homes@RESLuxuryGroup.com",
            "address": {
            "@context": "https://schema.org",
            "@type": "PostalAddress",
            "addressCountry": "US",
            "addressLocality": "Pine Ridge",
            "addressRegion": "FL",
            "postalCode": "34465"
            },
            "priceRange": "250,000+",
            "image": "https://www.guaranteedtosell.homes/assets/images/RES-Luxury-Group.webp",
            "knowsAbout": "Citrus County Florida realtors and luxury listing specialists with extensive financial background; work history in debt management, financial planning, and insurance. Our expertise in financial services brings more value to sellers as we can pre-qualify buyers and assist with financing options to get homes sold faster. We help buyers assess their financial means, evaluate loan options, and traverse through the purchase process easily.  As an equestrian enthusiasts, we specialize in marketing horse property and focus on sales in Pine Ridge Estates an equestrian and golf paradise in Beverly Hills FL! We have affiliations and memberships with a number of equestrian organizations across the country which allows us to provide national marketing within the tight knit horse network. Call us today (352-794-1426) to discuss how our specialized services in Citrus County real estate can benefit you!",
            "award": "Institute for Luxury Home Marketing - Member"
            }
            ]
            `}
        </Script>            
      </section>
    );
  } else {
    if (!isLoading && !isFetching) {
      // @ts-ignore
      window.location = window.location.href.slice(
        0,
        window.location.href.lastIndexOf("/")
      );
    } else
      return (
        <section>
          <div
            style={{
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              backgroundSize: "cover",
              opacity: 1,
              backgroundAttachment: "fixed",
              height: "100vh",
            }}
          >
            <div className="loading-wrapper h-100">
              <div className="loading-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </section>
      );
  }
}

export default ListingPage;